import React from "react"
import { createRoot } from "react-dom/client"
import { App } from "./team_manager/App"
import { AuthProvider } from "./team_manager/auth"
import { RouterProvider } from "./team_manager/router"
import { AppErrorBoundary } from "./team_manager/telemetry"

const root = document.getElementById("team-manager-root")

if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <AppErrorBoundary>
        <RouterProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </RouterProvider>
      </AppErrorBoundary>
    </React.StrictMode>
  )
}
